module.exports = __webpack_public_path__ + "2d98f668fad447a56e1f713a911aede9.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/projekte/netzbuehne01.jpg
// module id = 810
// module chunks = 0